import { supabase } from "../supabaseClient";
import {
  DEFAULT_DOUBLES_SINGLES_SETUP,
  effectiveDoublesSinglesSetup,
  normalizeDoublesSinglesSetup,
} from "./doublesSinglesSetup";
import {
  eventsBySquadFromRows,
  tournamentHasMixedDoublesSinglesSquad,
} from "./signupAvailability";

const actorId = async () => {
  const { data } = await supabase.auth.getUser();
  return data?.user?.id || null;
};

const tournamentHasMixedDoublesSinglesFromDb = async (tournamentId) => {
  const { data: events, error: eventsError } = await supabase
    .from("tournamentEvents")
    .select("id, bowlerQuantity, isPrimary, isDeleted")
    .eq("tournamentID", tournamentId)
    .eq("isPrimary", true)
    .eq("isDeleted", false);
  if (eventsError) throw eventsError;

  const { data: squads, error: squadsError } = await supabase
    .from("squads")
    .select("id, isDeleted")
    .eq("tournamentID", tournamentId)
    .eq("isDeleted", false);
  if (squadsError) throw squadsError;
  if (!squads?.length) return false;

  const { data: extraRows, error: extraError } = await supabase
    .from("squadEvents")
    .select("squadID, eventsID")
    .in(
      "squadID",
      squads.map((squad) => squad.id)
    );
  const eventsBySquad = extraError
    ? {}
    : eventsBySquadFromRows(extraRows || []);
  return tournamentHasMixedDoublesSinglesSquad(
    squads,
    events || [],
    eventsBySquad
  );
};

export const fetchDoublesSinglesSetup = async (tournamentId) => {
  if (!tournamentId) return { ...DEFAULT_DOUBLES_SINGLES_SETUP };
  const { data, error } = await supabase
    .from("tournamentDoublesSingles")
    .select("shareSquad, afterDoubles")
    .eq("tournamentID", tournamentId)
    .maybeSingle();
  if (error) throw error;
  const mixed = await tournamentHasMixedDoublesSinglesFromDb(
    tournamentId
  ).catch(() => false);
  return effectiveDoublesSinglesSetup(data, mixed);
};

export const saveDoublesSinglesSetupRow = async (tournamentId, setup) => {
  if (!tournamentId) {
    throw new Error("Tournament is required.");
  }
  const next = normalizeDoublesSinglesSetup(setup);
  const userId = await actorId();
  const now = new Date().toISOString();
  const row = {
    tournamentID: tournamentId,
    shareSquad: next.shareSquad,
    afterDoubles: next.afterDoubles,
    updatedAt: now,
    updatedBy: userId,
  };

  const { data: existing, error: existingError } = await supabase
    .from("tournamentDoublesSingles")
    .select("tournamentID, createdBy")
    .eq("tournamentID", tournamentId)
    .maybeSingle();
  if (existingError) throw existingError;

  const { error } = existing
    ? await supabase
        .from("tournamentDoublesSingles")
        .update(row)
        .eq("tournamentID", tournamentId)
    : await supabase.from("tournamentDoublesSingles").insert({
        ...row,
        createdAt: now,
        createdBy: userId,
      });
  if (error) throw error;
  return next;
};
